module.exports = __webpack_public_path__ + "static/DaniKang-af5c5d36cd467ed16443f8188b076af0.jpeg";